module.exports = __webpack_public_path__ + "img/c296557.jpg";